import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique cum
        qui, minus excepturi velit sed neque commodi rem deleniti a pariatur
        eaque facilis, repudiandae nobis odit ad nesciunt non voluptas tenetur
        ullam! Ad corporis officia, qui voluptas quo eaque saepe.
      </p>
    </section>
  );
};

export default About;
